'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_navigation_Button_Button = require('../Button/Button.cjs.js');
const components_navigation_DarkBackgroundButton_DarkBackgroundButton = require('../DarkBackgroundButton/DarkBackgroundButton.cjs.js');
const components_navigation_IconButton_IconButton = require('../IconButton/IconButton.cjs.js');
const components_navigation_DarkBackgroundIconButton_DarkBackgroundIconButton = require('../DarkBackgroundIconButton/DarkBackgroundIconButton.cjs.js');

const BackButton = ({ ariaLabel, children, href, isOnDarkBackground, onClick, size = "small", tooltipText }) => {
  const sharedProps = {
    "aria-label": ariaLabel,
    href,
    onClick
  };
  const ButtonComponent = isOnDarkBackground ? components_navigation_DarkBackgroundButton_DarkBackgroundButton.DarkBackgroundButton : components_navigation_Button_Button.Button;
  if (children) {
    return react.jsx(ButtonComponent, Object.assign({}, sharedProps, { color: "secondary", iconBefore: "arrowBigLeft", size }), children);
  } else {
    if (isOnDarkBackground) {
      return react.jsx(components_navigation_DarkBackgroundIconButton_DarkBackgroundIconButton.DarkBackgroundIconButton, Object.assign({}, sharedProps, { color: "icon-secondary", icon: "arrowBigLeft", label: tooltipText, tooltipPosition: "east" }));
    } else {
      return react.jsx(components_navigation_IconButton_IconButton.IconButton, Object.assign({}, sharedProps, { color: "icon-alt", icon: "arrowBigLeft", label: tooltipText, tooltipPosition: "east" }));
    }
  }
};

exports.BackButton = BackButton;
//# sourceMappingURL=BackButton.cjs.js.map
